// extracted by mini-css-extract-plugin
export var card = "_if-5";
export var cardSelected = "_if-4";
export var image = "_if-3";
export var modal = "_if-0";
export var modalContent = "_if-1";
export var table = "_if-2";